import { Injectable } from '@angular/core';
import { FrontendServices } from '@ibexfusion/core-utils';

@Injectable()
export class StorageService implements FrontendServices.StorageInterface {

  private storageKey = 'TNJtoM+O0eCjfnziQ3lsaHk7CxDYFoBGNwKniP2oOSA=';

  constructor() {

  }

  set(key: string, data: string): Promise<any> {
    key = FrontendServices.EncryptionService.hash(key);
    data = FrontendServices.EncryptionService.cryptSecretBox(data, this.storageKey);
    return new Promise((resolve) => {
      localStorage.setItem(key, data);
      resolve(true);
    });
    // return Promise.resolve(this.storage.set(key, data));
  }

  get(key: string): Promise<any> {
    const box = <string>localStorage.getItem(FrontendServices.EncryptionService.hash(key));
    if (!box) {
      return Promise.resolve(null);
    }
    return Promise.resolve(FrontendServices.EncryptionService.openSecretBox(box, this.storageKey));
  }

  remove(key: string): Promise<any> {
    return new Promise((resolve) => {
      localStorage.removeItem(FrontendServices.EncryptionService.hash(key));
      resolve(true);
    });
    // return Promise.resolve(this.storage.remove(FrontendServices.EncryptionService.hash(key)));
  }

  clear(): Promise<any> {
    return new Promise((resolve) => {
      localStorage.clear();
      resolve(true);
    });
  }

  ready(): Promise<any> {
    return Promise.resolve(true);
  }

  // Service to get and set Filter Data for data-table component

  setData(key: string, data: object): Promise<any> {
    return new Promise((resolve) => {
      localStorage.setItem(key, JSON.stringify(data));
      resolve(true);
    });
  }

  getData(key: string): Promise<any> {
    return new Promise((resolve) => {
      resolve(JSON.parse(localStorage.getItem(key)));
    });
    // return Promise.resolve(this.storage.get(key));
  }

  removeAllData(): Promise<any> {
    const allKeys = Object.keys(localStorage);
    allKeys.map(entry => {
      if (/data-table-filter/.test(entry)) {
        localStorage.removeItem(entry);
      }
    });
    return Promise.resolve(true);
  }
}
